<div class="d-flex flex-column justify-content-start align-items-start h-100 w-100">

    <div class="bg-grey-lighter-color  w-100 mb-3 p-2">
        <span class="fs-5 fw-bolder">Datos del participante</span>
    </div>

    <div class="w-100">

        <!-- NIF/NIE -->
        <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
            <span class="text-primary-color fw-bolder">DNI/NIE</span>
            <input type="text" pInputText class="w-100"
                [(ngModel)]="student.dni"
                (ngModelChange)="onStudentChange()"
                [readonly]="readonly"/>
        </div>

        <!-- Nombre -->
        <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
            <span class="text-primary-color fw-bolder" [appAsterisk]="true">Nombre</span>
            <input type="text" pInputText class="w-100"
                [(ngModel)]="student.name"
                (ngModelChange)="onStudentChange()"/>
        </div>

        <!-- Apellidos -->
        <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
            <span class="text-primary-color fw-bolder" [appAsterisk]="true">Apellidos</span>
            <input type="text" pInputText class="w-100"
                [(ngModel)]="student.surname"
                (ngModelChange)="onStudentChange()"/>
        </div>

        <!-- Fecha de nacimiento -->
        <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
            <span class="text-primary-color fw-bolder" [appAsterisk]="true">Fecha de nacimiento</span>
            <p-calendar
                class="w-100"
                styleClass="w-100"
                dateFormat="dd/mm/yy"
                [(ngModel)]="student.birthDate"
                (ngModelChange)="onStudentChange()"/>
        </div>

        <!-- Género -->
        <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
            <span class="text-primary-color fw-bolder" [appAsterisk]="true">Género</span>
            <app-gender-selector
                class="w-100"
                [genders]="genders"
                [(selected)]="selectedGender"
                (selectedChange)="onSelectedGenderChange()">
            </app-gender-selector>
        </div>

    </div>


</div>
